import React from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield} from 'lucide-react';
import './JobDescriptionLandingPage.css';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { useMediaQuery } from '@mui/material';
const features = [
  {
    icon: <Brain className="icon" />,
    title: 'Provide Key Details',
    description: 'Answer simple questions about the job, skills, and key details needed.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'Position or Role',
    description: 'Specify the exact job title to define the position and responsibilities.'
  },
  {
    icon: <Code className="icon" />,
    title: 'Let AI Generate',
    description: 'Our AI analyzes your input and creates a structured job description.'
  },
  {
    icon: <Database className="icon" />,
    title: 'Skills Required',
    description: 'List the essential skills and qualifications needed for this position.'
  },
  {
    icon: <BarChart className="icon" />,
    title: 'Use',
    description: 'Copy the job description and use it for job postings or recruitment.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Additional Information',
    description: 'Add company details, location, and any extra role-specific requirements.'
  },
];




const JobDescriptionLandingPage = () => {
  const navigate = useNavigate();

  const onClickHandle = () => {
    navigate('/jobdescription/login');
  };

  const isCustomSize = useMediaQuery("(max-width:770px)");
  return (
    <>
    <Header />
      <div className="jobDescription" style={{padding : '30px'}}>
        <div className="container">
          <div className="wrapper">
            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                Job <span className="highlight">Description</span> AI
              </h1>
              <p className="hero-description">
              Finding the right words for a job description can be challenging, but Your AI Utility Assistant makes it quick and easy! Our smart AI helps you craft clear, professional, and compelling job descriptions in just a few steps.
              </p>
            </div>

            {/* Features */}
            <div className="features-box">
              {!isCustomSize &&  <div style={{display : 'flex' , justifyContent : 'space-around'}}>
                <h2 className="features-heading">How It Works</h2>
                <h2 className="features-heading">What We Ask</h2>
              </div>}
              {isCustomSize && <h2 style={{fontSize : '22px'}} className="features-heading">What This AI Utility Does</h2>}
              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              {/* Optional button */}
              <button onClick={onClickHandle} className="cta-button">
                Try AI Utility Now
              </button>
              <p className="cta-note">No coding knowledge required • Easy setup in minutes</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default JobDescriptionLandingPage;
